import React from "react";
import { Flex, Table } from "antd/lib";
import { IPaymentDueSummary } from "../../../../interfaces/dashboard";
import { formatEuropeanCurrencyIntl } from "../../../../utils/helper";

interface PaymentsDueSummaryProps {
  data: IPaymentDueSummary[];
  loading?: boolean;
}

const PaymentDueSummary: React.FC<PaymentsDueSummaryProps> = ({
  data,
  loading = false,
}) => {

  const currencyPaymentColumns = [
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
      sorter: (a: any, b: any) => a.currency.localeCompare(b.currency),
    },
    {
      title: "Unmatched",
      dataIndex: "unmatched",
      key: "unmatched",
      align: "right" as const,
      sorter: (a: any, b: any) => (a.unmatched || 0) - (b.unmatched || 0),
      render: (v?: number) => (v ? formatEuropeanCurrencyIntl(v) : "-"),
    },
    {
      title: "Matched",
      dataIndex: "matched",
      key: "matched",
      align: "right" as const,
      sorter: (a: any, b: any) => (a.matched || 0) - (b.matched || 0),
      render: (v?: number) => (v ? formatEuropeanCurrencyIntl(v) : "-"),
    },
    {
      title: "Ready to Export",
      dataIndex: "readyToExport",
      key: "readyToExport",
      align: "right" as const,
      sorter: (a: any, b: any) => (a.readyToExport || 0) - (b.readyToExport || 0),
      render: (v?: number) => (v ? formatEuropeanCurrencyIntl(v) : "-"),
    },
    {
      title: "Pre-export Subtotal",
      dataIndex: "preExportSubtotal",
      key: "preExportSubtotal",
      align: "right" as const,
      sorter: (a: any, b: any) => (a.preExportSubtotal || 0) - (b.preExportSubtotal || 0),
      render: (v?: number) => (v ? formatEuropeanCurrencyIntl(v) : "-"),
    },
    {
      title: "Exported",
      dataIndex: "exported",
      key: "exported",
      align: "right" as const,
      sorter: (a: any, b: any) => (a.exported || 0) - (b.exported || 0),
      render: (v?: number) => (v ? formatEuropeanCurrencyIntl(v) : "-"),
    },
    {
      title: "Total in CHIP",
      dataIndex: "totalInChip",
      key: "totalInChip",
      align: "right" as const,
      sorter: (a: any, b: any) => (a.totalInChip || 0) - (b.totalInChip || 0),
      render: (v?: number) => (v ? formatEuropeanCurrencyIntl(v) : "-"),
    },
    {
      title: "Completed",
      dataIndex: "completed",
      key: "completed",
      align: "right" as const,
      sorter: (a: any, b: any) => (a.completed || 0) - (b.completed || 0),
      render: (v?: number) => (v ? formatEuropeanCurrencyIntl(v) : "-"),
    },
    {
      title: "Total Due",
      dataIndex: "totalDue",
      key: "totalDue",
      align: "right" as const,
      sorter: (a: any, b: any) => (a.totalDue || 0) - (b.totalDue || 0),
      render: (v?: number) => (v ? formatEuropeanCurrencyIntl(v) : "-"),
    },
  ];

  if (data) {
    return (
      <Flex
        className="legend"
        justify="center"
        wrap={true}
        style={{ width: "100%", borderRadius: 12 }}
      >
        <Table
          rowKey="currency"
          scroll={{ x: "max-content" }}
          style={{
            width: "100%",
          }}
          columns={currencyPaymentColumns}
          dataSource={data}
          pagination={false}
          size="small"
          className="table-fm"
          rowClassName={(record, index) => {
            let className = index % 2 === 0 ? "highlight-row" : "";
            return className.trim();
          }}
        />

      </Flex>
    );
  }
  return <></>;
};

export default React.memo(PaymentDueSummary);
